import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-787cbd4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "heading-md" }

import { ref } from 'vue';
import BtnIcon from '../BtnIcon/BtnIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InfoCard',
  props: {
    fullSize: { type: Boolean },
    title: {},
    isFoldable: { type: Boolean },
    stickyHeader: { type: Boolean }
  },
  setup(__props: any) {



const isCardOpen = ref(true);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['info-card', { 'info-card--full-size': _ctx.fullSize }])
  }, [
    (_ctx.title || _ctx.$slots.header)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['info-card__header', { 'info-card__header--sticky': _ctx.stickyHeader }])
        }, [
          _renderSlot(_ctx.$slots, "header", {}, () => [
            _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.title), 1)
          ]),
          (_ctx.isFoldable)
            ? (_openBlock(), _createBlock(BtnIcon, {
                key: 0,
                ariaLabel: "Hide / show card body",
                title: "Toggle card",
                iconName: isCardOpen.value ? 'bx-chevron-up' : 'bx-chevron-down',
                onClick: _cache[0] || (_cache[0] = () => (isCardOpen.value = !isCardOpen.value))
              }, null, 8, ["iconName"]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(['info-card__body', { 'info-card__body--closed': !isCardOpen.value }])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ], 2))
}
}

})